import React, { useEffect } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';

import Header from '../components/Header';
import Loader from '../components/Loader';
import ThemeHeader from '../components/Pages/Themes/ThemeHeader';
import ThemeRenderIntro from '../components/Pages/Themes/ThemeRenderIntro';
import Share from '../components/Pages/Share';
import ThemeCase from '../components/Pages/Themes/ThemeCase';
import ThemeArticles from '../components/Pages/Themes/ThemeArticles';
// import ThemeSlider from '../components/Pages/Themes/ThemeSlider';
import Footer from '../components/Footer';

import _ from 'lodash';

import { fetchSinglePost } from '../requests/singlepost_request';

const SingleThemes = (props) => {
    const getPosts = () => {
        props.fetchSinglePost('theme', props.match.params.slug);
    };

    const curPost = () => {
        if (props.posts.posts[0]) {
            const currentIndex = _.findIndex(props.posts.posts, [
                'slug',
                props.match.params.slug,
            ]);
            return currentIndex;
        } else {
            return 0;
        }
    };

    useEffect(() => {
        getPosts();
    }, []);

    return (
        <div className="theme single">
            <Loader loaded={props.posts.fetched || props.posts.failed} />
            {props.posts.fetched && (
                <Header
                    className="fadeIn"
                    isWork={true}
                    slider={props.posts.fetched && props.posts.posts[curPost()]}
                />
            )}
            <main>
                <div className="fadeIn">
                    {props.posts.fetched && (
                        <ThemeHeader
                            slider={
                                props.posts.fetched &&
                                props.posts.posts[curPost()]
                            }
                        />
                    )}
                    {props.posts.fetched && (
                        <div
                            className="theme__intro-block fadeIn"
                            style={{
                                backgroundColor:
                                    props.posts.fetched &&
                                    props.posts.posts[0].acf
                                        .work_colorpicker_bg,
                            }}>
                            <div className="clearfix" />
                            {props.posts.fetched &&
                                props.posts.posts[0].acf.slider && (
                                    <div className="content-container">
                                        <Share
                                            className="share-withcover fadeIn"
                                            title={
                                                props.posts.posts[curPost()]
                                                    .title.rendered || ''
                                            }
                                        />
                                        <div className="clearfix" />
                                        {props.posts.fetched && (
                                            <ThemeRenderIntro
                                                className="fadeIn"
                                                fields={
                                                    props.posts.posts[0].acf
                                                }
                                            />
                                        )}
                                    </div>
                                )}
                        </div>
                    )}
                </div>
                <div className="content-container">
                    <Link
                        to={{
                            pathname: '/behind-the-scenes',
                            state: { transition: 'slideLeft' },
                        }}
                        className="nav-btn">
                        <i className="icon icon-arrow_right" />
                        <span>Behind the scenes</span>
                    </Link>
                </div>
                {props.posts.fetched && (
                    <ThemeCase
                        className="fadeIn"
                        fields={props.posts.fetched && props.posts.posts[0].acf}
                    />
                )}
                <ThemeArticles
                    fields={props.posts.fetched && props.posts.posts[0].acf}
                />
                {/* {props.posts.fetched && (
                    <ThemeSlider
                        fields={props.posts.fetched && props.posts.posts[0].acf}
                        events={
                            props.posts.fetched &&
                            props.posts.posts[0].acf.selected_events
                        }
                    />
                )} */}
                <Footer />
            </main>
        </div>
    );
};

function mapStateToProps({ posts }) {
    return { posts };
}

export default withRouter(
    connect(mapStateToProps, { fetchSinglePost })(SingleThemes)
);



// WEBPACK FOOTER //
// ./src/containers/SingleThemes.jsx